import { useEffect } from 'react';

import { ReceivePacketCallback } from '../../../types';
import { useDownloadCafSDK } from './useDownloadCafSDK';
import { useRequestCafPacket } from './useRequestCafPacket';

import * as Types from '../types';

export const useCafIntegration = ({
    sdk,
    enable,
    sdkUrl,
    transactionID,
    onConnect,
    onError,
    receivePacket,
    geolocationType
}: {
    sdk: Types.CAFSdkInstance | null;
    enable: boolean;
    sdkUrl: string;
    transactionID: string | null;
    onConnect: CallableFunction;
    onError: CallableFunction;
    receivePacket: ReceivePacketCallback;
    geolocationType: string;
}) => {
    const downloadCafSDK = useDownloadCafSDK({ sdkUrl });
    const requestCafPacket = useRequestCafPacket({
        sdk,
        transactionID,
        onError,
        receivePacket,
        geolocationType
    });

    useEffect(() => {
        if (!enable || !sdk) {
            return;
        }

        onConnect();
    }, [sdk, enable, onConnect]);

    return {
        requestCafPacket,
        downloadCafSDK
    };
};
